import React, { useState } from 'react';
import styles from './CommonSlider.module.scss';

const CommonSlider = ({ value, defaultValue, onChange, min = 0, max = 100, step = 1, unit, disabled = false, name, ...rest }) => {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue ?? min);

  const currentValue = isControlled ? value : internalValue;

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    if (!isControlled) {
      setInternalValue(newValue);
    }
    onChange?.(newValue);
  };

  return (
    <div className={styles['slider-container']} {...rest}>
        <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={currentValue ?? ''}
            onChange={handleChange}
            className={styles['slider-slide']}
            disabled={disabled}
            name={name}
        />
        <input 
            type="number" 
            step={step} 
            value={currentValue ?? ''} 
            onChange={handleChange}
            className={`${styles['slider-input']} form-control`}
            disabled={disabled}
        />
        {unit && <span>{unit}</span>}
    </div>
  );
}

export default CommonSlider;